import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=780f6f86&scoped=true"
import script from "./BlackList.vue?vue&type=script&lang=js"
export * from "./BlackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780f6f86",
  null
  
)

export default component.exports